// extracted by mini-css-extract-plugin
export var wrapper = "secondary-text-module--wrapper--9a6e5";